// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Recoil from "recoil";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as RescriptReactRouter from "@rescript/react/src/RescriptReactRouter.bs.js";
import * as Icon$OrcaPaymentPage from "../Icon.bs.js";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";
import * as Spinner$OrcaPaymentPage from "../Components/Spinner.bs.js";
import * as CardUtils$OrcaPaymentPage from "../CardUtils.bs.js";
import * as PaymentBody$OrcaPaymentPage from "../Utilities/PaymentBody.bs.js";
import * as RecoilAtoms$OrcaPaymentPage from "../Utilities/RecoilAtoms.bs.js";
import * as PaymentUtils$OrcaPaymentPage from "../Utilities/PaymentUtils.bs.js";
import * as PaymentHelpers$OrcaPaymentPage from "../Utilities/PaymentHelpers.bs.js";

function PazeButton(props) {
  var token = props.token;
  var url = RescriptReactRouter.useUrl(undefined, undefined);
  var componentName = CardUtils$OrcaPaymentPage.getQueryParamsDictforKey(url.search, "componentName");
  var match = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.keys);
  var iframeId = match.iframeId;
  var publishableKey = match.publishableKey;
  var sdkAuthorization = match.sdkAuthorization;
  var match$1 = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.configAtom);
  var themeObj = match$1.themeObj;
  var updateSession = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.updateSession);
  var options = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.optionAtom);
  var setIsShowOrPayUsing = Recoil.useSetRecoilState(RecoilAtoms$OrcaPaymentPage.isShowOrPayUsing);
  var loggerState = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.loggerAtom);
  var isManualRetryEnabled = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.isManualRetryEnabled);
  var intent = PaymentHelpers$OrcaPaymentPage.usePaymentIntent(loggerState, "Paze");
  var paymentIntentId = Utils$OrcaPaymentPage.getPaymentIdOrExtractFromSdkAuth(Core__Option.getOr(match.clientSecret, ""), Utils$OrcaPaymentPage.getNonEmptyOption(sdkAuthorization));
  var match$2 = React.useState(function () {
        return false;
      });
  var setShowLoader = match$2[1];
  var showLoader = match$2[0];
  var isTestMode = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.isTestMode);
  var match$3 = PaymentUtils$OrcaPaymentPage.useNonPiiAddressData();
  var pinCode = match$3.pinCode;
  var state = match$3.state;
  var country = match$3.country;
  var onClick = function (param) {
    if (isTestMode) {
      console.warn("Paze button clicked in test mode - interaction disabled");
      return loggerState.setLogInfo("Paze button clicked in test mode - interaction disabled", "PAZE_SDK_FLOW", undefined, undefined, undefined, undefined, "PAZE");
    }
    loggerState.setLogInfo("Paze SDK Button Clicked", "PAZE_SDK_FLOW", undefined, undefined, undefined, undefined, "PAZE");
    PaymentUtils$OrcaPaymentPage.emitPaymentMethodInfo("wallet", "paze", undefined, undefined, undefined, undefined, undefined, country, state, pinCode, undefined, undefined);
    setShowLoader(function (param) {
          return true;
        });
    var metadata = Utils$OrcaPaymentPage.getJsonFromArrayOfJson([
          [
            "componentName",
            componentName
          ],
          [
            "wallet",
            token.walletName
          ],
          [
            "clientId",
            token.clientId
          ],
          [
            "clientName",
            token.clientName
          ],
          [
            "clientProfileId",
            token.clientProfileId
          ],
          [
            "sessionId",
            paymentIntentId
          ],
          [
            "publishableKey",
            publishableKey
          ],
          [
            "emailAddress",
            token.email_address
          ],
          [
            "transactionAmount",
            token.transaction_amount
          ],
          [
            "transactionCurrencyCode",
            token.transaction_currency_code
          ]
        ]);
    Utils$OrcaPaymentPage.messageParentWindow(undefined, [
          [
            "fullscreen",
            true
          ],
          [
            "param",
            "pazeWallet"
          ],
          [
            "iframeId",
            iframeId
          ],
          [
            "metadata",
            metadata
          ]
        ]);
  };
  React.useEffect((function () {
          var handlePazeCallback = function (ev) {
            var json = Utils$OrcaPaymentPage.safeParse(ev.data);
            var dict = Utils$OrcaPaymentPage.getDictFromDict(Utils$OrcaPaymentPage.getDictFromJson(json), "data");
            if (!Utils$OrcaPaymentPage.getBool(dict, "isPaze", false)) {
              return ;
            }
            setShowLoader(function (param) {
                  return false;
                });
            Utils$OrcaPaymentPage.messageParentWindow(undefined, [
                  [
                    "fullscreen",
                    true
                  ],
                  [
                    "param",
                    "paymentloader"
                  ],
                  [
                    "iframeId",
                    iframeId
                  ]
                ]);
            if (!Core__Option.isSome(Utils$OrcaPaymentPage.getOptionString(dict, "completeResponse"))) {
              return ;
            }
            var completeResponse = Utils$OrcaPaymentPage.getString(dict, "completeResponse", "");
            intent(false, PaymentBody$OrcaPaymentPage.pazeBody(completeResponse), {
                  return_url: options.wallets.walletReturnUrl,
                  publishableKey: publishableKey
                }, undefined, undefined, undefined, isManualRetryEnabled, undefined);
          };
          setIsShowOrPayUsing(function (param) {
                return true;
              });
          window.addEventListener("message", handlePazeCallback);
          return (function () {
                    window.removeEventListener("message", handlePazeCallback);
                  });
        }), [sdkAuthorization]);
  return React.createElement("button", {
              className: "w-full flex flex-row justify-center items-center",
              style: {
                backgroundColor: "#2B63FF",
                border: themeObj.buttonBorderWidth + " solid " + themeObj.buttonBorderColor,
                cursor: showLoader ? "not-allowed" : "pointer",
                height: themeObj.buttonHeight,
                width: themeObj.buttonWidth,
                opacity: showLoader || updateSession ? "0.5" : "1.0",
                borderRadius: themeObj.buttonBorderRadius,
                pointerEvents: updateSession ? "none" : "auto"
              },
              disabled: showLoader,
              onClick: onClick
            }, showLoader ? React.createElement(Spinner$OrcaPaymentPage.make, {}) : React.createElement(Icon$OrcaPaymentPage.make, {
                    name: "paze",
                    size: 55
                  }));
}

var make = PazeButton;

export {
  make ,
}
/* react Not a pure module */
